<app-question-card class="bottom-gradient">
  <p question>One last question,<br></p>
  <p question>{{ isTurboJourney ? "What is the lead source?" : "How did you hear about us?" }}</p>
  <div class="form-field" input-options>
    <div class="radio-option-arrow" *ngFor="let option of hearAboutUsOptions">
      <input
        type="radio"
        [id]="option.name"
        name="sell-concern"
        [value]="option.value"
        [(ngModel)]="howDidYouHear"
        (click)="submit(option.value)"
      />
      <label [for]="option.name">
        <div class="mr-2">
          <p>{{ option.name }}</p>
        </div>
        <app-icon class="ml-auto" color="var(--color-primary)" fontWeight="100" fontSize="32">right</app-icon>
      </label>
    </div>
  </div>
  <p class="chat-answer" answer>{{howDidYouHear}}</p>
</app-question-card>
